import React from 'react';
import { Route } from 'react-router-dom';
import path from './path';
import config from '../config';
export var checkForLoginParam = function checkForLoginParam() {
  var forceLogIn = config.LandingPage.forceLogIn;
  if (forceLogIn && checkForConfigLinks()) return false;
  if (window.location.href.includes(forceLogIn ? '' : 'login')) return true;
  return false;
};
var checkForConfigLinks = function checkForConfigLinks() {
  var hasLinks = false;
  var checkURL = [config.documentationLink, config.SignupForm.termsAndServicesLink, config.SignupForm.privacyPolicyLink];
  for (var urlNum = 0; urlNum < checkURL.length; urlNum++) {
    if (checkURL[urlNum] !== '/' && window.location.href.includes(checkURL[urlNum])) {
      hasLinks = true;
    }
  }
  return hasLinks;
};
export var checkForVerifyEmailParam = function checkForVerifyEmailParam() {
  if (window.location.href.includes('verifyEmail')) return true;
  return false;
};
export var checkForConfirmWithdrawParam = function checkForConfirmWithdrawParam() {
  if (window.location.href.includes('confirmWithdraw')) return true;
  return false;
};
export var checkForResetPassParam = function checkForResetPassParam() {
  if (window.location.href.includes('resetPass')) return true;
  return false;
};
export var checkForVerifyDeviceParam = function checkForVerifyDeviceParam() {
  if (window.location.href.includes('verifyDevice')) return true;
  return false;
};
export var checkForDepositConfirmationParam = function checkForDepositConfirmationParam() {
  var href = window.location.href;
  var trustPayRedirect = href.includes('id') && href.includes('resourcePath');
  if (href.includes('txnState') || trustPayRedirect) return true;
  return false;
};
export var checkForVerifyAddressParam = function checkForVerifyAddressParam() {
  if (window.location.href.includes('verifyWithdrawAddress')) return true;
  return false;
};
export var homePageRoutes = function homePageRoutes(pathname, HomePage) {
  return (pathname.includes('.html') || pathname === path('/')) && React.createElement(Route, {
    exact: true,
    path: pathname,
    key: pathname,
    component: HomePage
  });
};